import { clone } from "lodash";

export function buildUrl(originalImageUrl, filterParam) {
  let original = clone(originalImageUrl);
  let filter = clone(filterParam);
  if (!filter) {
    return original; // If the "none" option is selected, return the original url
  }
  if (original[original.length - 1] == "/") {
    original = original.substr(0, original.length - 1);
  }
  let indexOfSlash = original.lastIndexOf("/");
  let originalBegin = original.substr(0, indexOfSlash);
  let imageKey = original.substr(indexOfSlash + 1);

  let fullUrl = originalBegin + "/" + filter + "/" + imageKey;
  return fullUrl;
}
